<template>

  <div>

    <el-tabs v-model="activeTab">
      <el-tab-pane name="Users" label="Users">
        <users-data
          :branch-options="branchOptions"
        />
      </el-tab-pane>
      <el-tab-pane name="dids" label="Phone Numbers">
        <numbers-data
          :branch-options="branchOptions"
        />
      </el-tab-pane>
    </el-tabs>

  </div>

</template>

<script>

import UsersData from './components/users-data-vxe';
import NumbersData from './components/numbers-data-vxe';
import feathersClient from "@/feathers/feathers-client";

export default {
  name: 'CallStats',
  components: {UsersData, NumbersData},
  computed: {
    selectedTenant(){
      return this.$store.state.selectedTenant;
    }
  },
  watch: {
    selectedTenant(){
      this.queryBranches();
    }
  },
  data() {
    return {
      activeTab: 'Users',
      branchOptions: []
    }
  },
  methods: {
    queryBranches(){
      feathersClient.service('branches').find({
        query: {
          tenantId: this.selectedTenant.id
        }
      }).then(res => {
        this.branchOptions = res;
      }).catch( () => {
        this.branchOptions = [];
      });
    },
  },
  mounted(){
    this.queryBranches();
  }
}

</script>
